<script setup>
import { ref, getCurrentInstance, onBeforeUnmount, defineEmits, defineProps, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import KSATextButton from "../../../../../components/ui-components/button/KSATextButton.vue";
import adminJobfairStateService from "../../../services/jobfair/adminJobfairStateService";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import { useUserStore } from "../../../../user/stores/user";
import jobFairUserService from "../../../../user/services/jobFair/jobFairUserService";
import JobFairJobNoticeDetailModal from "../../../../user/components/modal/jobFair/JobFairJobNoticeDetailModal.vue";
import { useAlertStore } from "../../../../../stores/alertStore";
import JobFairResumeDetailModal from "../../../../user/components/modal/jobFair/JobFairResumeDetailModal.vue";
import mypageJobFairApplicantService from "../../../../user/services/mypage/jobFair/mypageJobFairApplicantService";


const { $alert, $confirm } = useAlertStore();

const route = useRoute()
const router = useRouter()
const loadingStore = usePageLoadingStore()
const { user, isAuthenticated } = useUserStore()
const globals = getCurrentInstance().appContext.config.globalProperties;
const { $pageListBoardNo, $number, $gbNameKR, $yyyymmddHHmmss } = globals;

const props = defineProps({
  jobNoticeSeq: {
    type: [String, Number],
    default: null,
  },
  corpId: {
    type: [String, Number],
    default: null,
  }
});

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);
const list = ref([]);

// 모달
const jobNoticeModal = ref(null); // 채용공고
const jobFairResumeModal = ref(null); // 이력서

watch(() => props.jobNoticeSeq, (newJobNoticeSeq) => {
  if (newJobNoticeSeq) {
    retrieveList(newJobNoticeSeq);
  } else {
    list.value = [];
    totalCount.value = 0;
    totalPages.value = 1;
    currentPage.value = 1;
  }
}, { immediate: true });

const retrieveList = (jobNoticeSeq) => {
  let paramObj = {
    jobNoticeSeq: jobNoticeSeq,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }

  loadingStore.loading = true;
  adminJobfairStateService.retrieveResumeListByJobNoticeSeqAdminPaging(paramObj)
    .then( (res) => {
      loadingStore.loading = false;
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        // console.log(result);
        totalPages.value = result.totalPages;
        totalCount.value = result.totalElements;
        list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
      }
    }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, corpId) => {
  await jobNoticeModal.value.show({
    jobNoticeSeq,
    corpId,
  });
}


// 이력서 보기
const onClickMyResume = async (resumeId) => {
  await jobFairResumeModal.value.show({
    resumeId,
    showDeleteBtn: false,
  });
}

// 입사지원 상태변경 joinStateGb
// 입사지원 상태변경 joinStateGb
const onClickApplyStateGb = async (resumeId, jobNoticeSeq, stateGb) => {
  let modalContent, okButtonText;
  if (stateGb === "02") {
    modalContent = ["지원취소 처리하시겠습니까?", "'지원취소'로 상태가 변경됩니다."];
    okButtonText = "지원취소";
  } else if (stateGb === "03") {
    modalContent = ["서류합격 처리하시겠습니까?", "'서류합격'으로 상태가 변경됩니다."];
    okButtonText = "서류합격";
  } else if (stateGb === "04") {
    modalContent = ["서류불합격 처리하시겠습니까?", "'서류불합격'으로 상태가 변경됩니다."];
    okButtonText = "서류불합격";
  } else if (stateGb === "05") {
    modalContent = ["최종합격 처리하시겠습니까?", "'최종합격'으로 상태가 변경됩니다."];
    okButtonText = "최종합격";
  } else if (stateGb === "06") {
    modalContent = ["최종불합격 처리하시겠습니까?", "'최종불합격'으로 상태가 변경됩니다."];
    okButtonText = "최종불합격";
  }

  const ok = await $confirm(modalContent, okButtonText);
  if(ok) {
    const paramObj = {
      resumeId,
      jobNoticeSeq,
      applyStateGb: stateGb,
    };

    mypageJobFairApplicantService.updateApplyStateGb(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          alert("변경하였습니다.");
          retrieveList(jobNoticeSeq);
        } else {
          alert("변경을 실패하였습니다.");
        }
      })
      .catch( (res) =>  {
        loadingStore.loading = false;
        alert("변경을 실패하였습니다.");
      });
  }
}

const openDetailInNewTab = (linkName, id = {}) => {
  const url = router.resolve({
    name: linkName,
    params: { id },
  }).href;

  window.open(url, '_blank');
}

const emit = defineEmits(['go-back']);

const goBack = () => {
  emit('go-back');
}
</script>

<template>
  <div>
    <KSASecondaryButton text="이전" @click="goBack()" />
    <div class="list-top">
      <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
      <div>
        <KSAPrimaryButton text="채용공고 보기" @click="onClickJobNotice(props.jobNoticeSeq, props.corpId)" />
      </div>
    </div>
    <div class="table-form">
      <table class="horizontal" v-if="list !== null">
        <tr>
          <th>NO</th>
          <th>회원코드</th>
          <th>이름</th>
          <th>아이디</th>
          <th>이력서 제목</th>
          <th>관심 카테고리</th>
          <th>전공계열(주전공)</th>
          <th>입사 지원일</th>
          <th>상태</th>
          <th>상태변경</th>
        </tr>
        <tr v-for="applicant in list">
          <td>{{ applicant.boardNo }}</td>
          <td>{{ applicant.userCd }}</td>
          <td class="clickable blue">
            <span @click="openDetailInNewTab('MemberDetail', applicant.userCd)">{{ applicant.userName }}</span>
          </td>
          <td>{{ applicant.userLoginId }}</td>
          <td class="text-overflow long-overflow">
            <span class="blue file" v-if="applicant.fileYn === 'Y'" v-for="resumeAttaches in applicant.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
              {{ resumeAttaches.fileName }}
            </span>
            <span class="clickable blue" v-else @click="onClickMyResume(applicant.resumeId)">
              {{ applicant.title }}
            </span>
          </td>
          <td>
            <span v-if="applicant.fileYn !== 'Y'">{{ applicant.interests }}</span>
            <span v-else>-</span>
          </td>
          <td>{{ $gbNameKR('MAJOR_GB', applicant.majorGb) }}</td>
          <td>{{ $yyyymmddHHmmss(applicant.createDate) }}</td>
          <td>
            <span v-if="applicant.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',applicant.applyStateGb) }}</span>
            <span v-else-if="applicant.applyStateGb === '03' || applicant.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',applicant.applyStateGb) }}</span>
            <span v-else-if="applicant.applyStateGb === '04' || applicant.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',applicant.applyStateGb) }}</span>
            <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',applicant.applyStateGb) }}</span>
          </td>
          <td>
            <div v-if="applicant.applyStateGb === '01'">
              <!-- 지원완료 -->
              <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '03')"/>
              &nbsp;
              <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '04')"/>
            </div>
            <div v-else-if="applicant.applyStateGb === '03'">
              <!-- 서류합격 -->
              <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '04')"/>
              <br/>
              <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '05')"/>
              &nbsp;
              <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '06')"/>
            </div>
            <div v-else-if="applicant.applyStateGb === '04'">
              <!-- 서류불합격 -->
              <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '03')"/>
            </div>
            <div v-else-if="applicant.applyStateGb === '05'">
              <!-- 최종합격 -->
              <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '06')"/>
            </div>
            <div v-else-if="applicant.applyStateGb === '06'">
              <!-- 최종불합격 -->
              <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '05')"/>
            </div>
            <div v-else>
              -
            </div>
          </td>
        </tr>
      </table>
      <div class="result-none" v-if="list.length === 0">
        입사지원 내역이 없습니다.
      </div>
    </div>
    <Paginate
      v-if="list.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
    />
    <JobFairJobNoticeDetailModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
    <JobFairResumeDetailModal ref="jobFairResumeModal" /> <!-- 특별채용관 이력서 상세 -->
  </div>
</template>

<style scoped>

</style>
